<template>
  <div class="row">
    <div class="span8 detail-main">
      <el-page-header @back="$router.back()" :content="company.company_name" style="margin-bottom: 18px;"></el-page-header>
      <div style="background: #f8f9fa; border-radius: 4px; padding: 16px 20px; margin-bottom: 20px;">
        <div class="info-unit"><span class="tagname">公司规模</span>{{ company.company_scale }}</div>
      </div>
      <h3 style="font-size: 18px; margin-bottom: 12px;">公司介绍</h3>
      <blockquote class="post-body" v-html="company.company_content" style="margin: 0 0 24px;"></blockquote>
      <h3 style="font-size: 18px; margin-bottom: 12px;">岗位列表</h3>
      <div v-for="job in joblist" :key="job.job_id" style="padding: 12px 0;">
        <el-divider v-if="joblist.indexOf(job) > 0"></el-divider>
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <router-link :to="`/jobcontent/${job.job_id}`" style="color: #333; font-size: 15px;">{{ job.job_name }}</router-link>
          <span style="color: #e60000; font-weight: bold;">{{ job.job_salary }}</span>
        </div>
      </div>
      <p v-if="!joblist.length" style="color: #999;">该公司暂无在招岗位</p>
      <div style="margin: 24px 0; text-align: center;">
        <el-button round disabled>👍 66</el-button>
      </div>
    </div>
    <div class="span4 page-sidebar">
      <carousel-widget />
      <company-widget />
    </div>
    <div class="span8">
      <comment-widget />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import carouselWidget from '@/components/carousel.vue'
import companyWidget from '@/components/company.vue'
import commentWidget from '@/components/comment.vue'
import { getCompanyContent } from '@/api'

export default {
  name: 'CompanyContent',
  components: { carouselWidget, companyWidget, commentWidget },
  props: { id: { type: String, default: '' } },
  data() {
    return { company: {}, joblist: [] }
  },
  computed: {
    ...mapState({ commentnum: (s) => s.commentnum })
  },
  watch: {
    id: { immediate: true, handler() { this.getcontent() } }
  },
  methods: {
    getcontent() {
      if (!this.id) return
      getCompanyContent(this.id).then((res) => {
        this.company = (res.data && res.data.company) || {}
        this.joblist = (res.data && res.data.joblist) || []
        this.$store.dispatch('setcontentid', this.id)
        this.$store.dispatch('setcontentinfo', { name: this.company.company_name, userid: this.company.user_id })
      })
    }
  }
}
</script>
